// Study Groups listing data - currently empty, coming soon
export const studyGroups = [];
